import React from 'react';
import { ErrorPage } from '../ErrorPage';

export const InternalError: React.FC = () => (
  <ErrorPage
    title='500 Something went wrong'
    message={
      <span>
        An unexpected error occurred. Please refresh your browser or begin another session. If the error persists,
        please contact the BTS help desk.
      </span>
    }
  />
);
